module.exports = __webpack_public_path__ + "static/media/empty-result.37d79771.svg";